import React from 'react';


const IconWrapper = (path, viewboxDefault = 16) => {
    return (
        <span className="bp4-icon">
            <svg version="1.1" xmlns="http://www.w3.org/2000/svg" x="0" y="0"
                 width={viewboxDefault} height={viewboxDefault}
                 fillRule={'evenodd'}
                 viewBox={`0 0 ${viewboxDefault} ${viewboxDefault}`}
            >
                {path}
            </svg>
        </span>
    );
};


const AddTagIcon = (props = { size: 16 }) => {

    const { size } = props;

    let path = [
        <path fillRule={'evenodd'} d="M0,2.769l0,3.976c0,0.204 0.081,0.399 0.225,0.543l8.488,8.487c0.3,0.3 0.785,0.3 1.085,0l3.977,-3.976c0.3,-0.3 0.3,-0.786 0,-1.085l-8.488,-8.488c-0.144,-0.144 -0.339,-0.224 -0.543,-0.224l-3.977,-0c-0.424,-0 -0.767,0.343 -0.767,0.767Zm3.554,1.757c-0,-0.564 -0.458,-1.022 -1.023,-1.022c-0.565,-0 -1.023,0.458 -1.023,1.022c0,0.565 0.458,1.023 1.023,1.023c0.565,0 1.023,-0.458 1.023,-1.023Z"/>,
        <path fillRule={'evenodd'} d="M13.5,2.5l0,-2.5l-2,0l0,2.5l-2.5,0l0,2l2.5,0l0,2.5l2,0l0,-2.5l2.5,0l0,-2l-2.5,0Z"/>
    ];
    if (size > 16)
    {
        path = [
            <path fillRule={'evenodd'} d="M0,3.461l0,4.971c0,0.254 0.101,0.498 0.281,0.678l10.611,10.609c0.374,0.375 0.981,0.375 1.356,0l4.971,-4.971c0.375,-0.374 0.375,-0.981 0,-1.356l-10.611,-10.609c-0.179,-0.18 -0.423,-0.281 -0.678,-0.281l-4.971,0c-0.53,0 -0.959,0.429 -0.959,0.959Zm4.442,2.197c0,-0.706 -0.572,-1.278 -1.278,-1.278c-0.706,-0 -1.279,0.572 -1.279,1.278c0,0.706 0.573,1.278 1.279,1.278c0.706,0 1.278,-0.572 1.278,-1.278Z"/>,
            <path fillRule={'evenodd'} d="M16.875,3.125l0,-3.125l-2.5,0l0,3.125l-3.125,0l0,2.5l3.125,0l0,3.125l2.5,0l0,-3.125l3.125,0l0,-2.5l-3.125,0Z"/>
        ]
    }
    return IconWrapper(
        <g>
            {path.map((e,i) => ({...e, key: i}))}
        </g>,
        size ?? 16
    )
}


const EditTagIcon = (props = { size: 16 }) => {

    const { size } = props;

    let path = [
        <path fillRule={'evenodd'} d="M3.932,10.995l3.706,-6.418l-2.351,-2.351c-0.144,-0.144 -0.339,-0.224 -0.543,-0.224l-3.977,-0c-0.424,-0 -0.767,0.343 -0.767,0.767l0,3.976c0,0.204 0.081,0.399 0.225,0.543l3.707,3.707Zm-0.378,-6.469c-0,-0.564 -0.458,-1.022 -1.023,-1.022c-0.565,-0 -1.023,0.458 -1.023,1.022c0,0.565 0.458,1.023 1.023,1.023c0.565,0 1.023,-0.458 1.023,-1.023Z"/>,
        <path fillRule={'evenodd'} d="M16,2.5l-4.33,-2.5l-5.846,10.125l0.217,4.625l4.113,-2.125l5.846,-10.125Zm-1.353,0.344l-0.866,-0.5l-5.359,9.281l0.866,0.5l5.359,-9.281Zm-1.732,-1l-0.866,-0.5l-5.359,9.281l0.866,0.5l5.359,-9.281Z"/>
    ];
    if (size > 16)
    {
        path = [
            <path fillRule={'evenodd'} d="M4.571,13.399l4.632,-8.022l-2.595,-2.594c-0.179,-0.18 -0.423,-0.281 -0.678,-0.281l-4.971,0c-0.53,0 -0.959,0.429 -0.959,0.959l0,4.971c0,0.254 0.101,0.498 0.281,0.678l4.29,4.289Zm-0.129,-7.741c0,-0.706 -0.572,-1.278 -1.278,-1.278c-0.706,-0 -1.279,0.572 -1.279,1.278c0,0.706 0.573,1.278 1.279,1.278c0.706,0 1.278,-0.572 1.278,-1.278Z"/>,
            <path fillRule={'evenodd'} d="M20,3.5l-6.062,-3.5l-6.669,11.55l0.174,6.7l5.889,-3.2l6.668,-11.55Zm-4.3,-1.125l-1.099,-0.65l-5.992,10.325l1.099,0.65l5.992,-10.325Zm2.484,1.45l-1.099,-0.65l-5.992,10.325l1.099,0.65l5.992,-10.325Z"/>
        ]
    }
    return IconWrapper(
        <g>
            {path.map((e,i) => ({...e, key: i}))}
        </g>,
        size ?? 16
    )
}


const DeleteTagIcon = (props = { size: 16 }) => {

    const { size } = props;

    let path = [
        <path d="M0,0.769l0,3.976c0,0.204 0.081,0.399 0.225,0.543l1.488,1.488l5.062,-5.061l-1.488,-1.489c-0.144,-0.144 -0.339,-0.224 -0.543,-0.224l-3.977,-0c-0.424,-0 -0.767,0.343 -0.767,0.767Zm3.554,1.757c-0,-0.564 -0.458,-1.022 -1.023,-1.022c-0.565,-0 -1.023,0.458 -1.023,1.022c0,0.565 0.458,1.023 1.023,1.023c0.565,0 1.023,-0.458 1.023,-1.023Z"/>,
        <path d="M9.636,6.808l-3.535,-3.536l-2.829,2.829l3.536,3.535l-3.536,3.536l2.829,2.828l3.535,-3.536l3.536,3.536l2.828,-2.828l-3.536,-3.536l3.536,-3.535l-2.828,-2.829l-3.536,3.536Z"/>
    ];
    if (size > 16)
    {
        path = [
            <path d="M0,0.959l0,4.971c0,0.254 0.101,0.498 0.281,0.678l3.611,3.609l6.327,-6.327l-3.611,-3.609c-0.179,-0.18 -0.423,-0.281 -0.678,-0.281l-4.971,0c-0.53,0 -0.959,0.429 -0.959,0.959Zm4.442,2.197c0,-0.706 -0.572,-1.278 -1.278,-1.278c-0.706,-0 -1.279,0.572 -1.279,1.278c0,0.706 0.573,1.278 1.279,1.278c0.706,0 1.278,-0.572 1.278,-1.278Z"/>,
            <path d="M13.064,10.205l-3.788,-3.788l-2.909,2.909l3.788,3.788l-3.636,3.637l3.03,3.03l3.637,-3.636l3.788,3.788l2.909,-2.909l-3.788,-3.788l3.636,-3.637l-3.03,-3.03l-3.637,3.636Z"/>
        ]
    }
    return IconWrapper(
        <g>
            {path.map((e,i) => ({...e, key: i}))}
        </g>,
        size ?? 16
    )
}


const ListTagsIcon = (props = { size: 16 }) => {

    const { size } = props;

    let path = [
        <path d="M6,11.062l0,-8.062l2.061,0l-2.774,-2.774c-0.144,-0.144 -0.339,-0.224 -0.543,-0.224l-3.977,-0c-0.424,-0 -0.767,0.343 -0.767,0.767l0,3.976c0,0.204 0.081,0.399 0.225,0.543l5.775,5.774Zm-2.446,-8.536c-0,-0.564 -0.458,-1.022 -1.023,-1.022c-0.565,-0 -1.023,0.458 -1.023,1.022c0,0.565 0.458,1.023 1.023,1.023c0.565,0 1.023,-0.458 1.023,-1.023Z"/>,
        <path d="M16,4l-9,0l0,12l9,0l0,-12Zm-1,1l-7,0l0,10l7,0l0,-10Z"/>,
        <rect x="9" y="6" width="5" height="1.5"/>,
        <rect x="9" y="9.3" width="3" height="1.5"/>,
        <rect x="9" y="12.5" width="5" height="1.5"/>
    ];
    if (size > 16)
    {
        path = [
            <path d="M20,4l-11,0l0,16l11,0l0,-16Zm-1.5,1.5l-8,0l0,13l8,0l0,-13Z"/>,
            <rect x="12" y="7" width="5" height="2"/>,
            <rect x="12" y="11" width="3" height="2"/>,
            <rect x="12" y="15" width="5" height="2"/>,
            <path d="M8,14.326l-0,-11.326l1.328,-0l-2.72,-2.719c-0.179,-0.18 -0.423,-0.281 -0.678,-0.281l-4.971,-0c-0.53,-0 -0.959,0.429 -0.959,0.959l0,4.971c0,0.254 0.101,0.498 0.281,0.678l7.719,7.718Zm-3.558,-11.17c0,-0.706 -0.572,-1.278 -1.278,-1.278c-0.706,-0 -1.279,0.572 -1.279,1.278c0,0.706 0.573,1.278 1.279,1.278c0.706,0 1.278,-0.572 1.278,-1.278Z"/>,
        ]
    }
    return IconWrapper(
        <g>
            {path.map((e,i) => ({...e, key: i}))}
        </g>,
        size ?? 16
    )
}


const TagsLegendIcon = (props = { size: 16 }) => {

    const { size } = props;

    let path = [
        <path d="M2,1l2,2l-2,2l-2,-2l2,-2Z"/>,
        <circle cx="2" cy="8" r="2"/>,
        <path d="M2,11l2,4l-4,0l2,-4Z"/>,
        <rect x="6" y="2" width="10" height="2"/>,
        <rect x="6" y="7" width="10" height="2"/>,
        <rect x="6" y="12" width="10" height="2"/>
    ];
    if (size > 16)
    {
        path = [
            <path d="M3,0l3,3l-3,3l-3,-3l3,-3Z"/>,
            <circle cx="3" cy="10" r="3"/>,
            <path d="M3,14l3,6l-6,0l3,-6Z"/>,
            <rect x="8" y="1.5" width="12" height="3"/>,
            <rect x="8" y="8.5" width="12" height="3"/>,
            <rect x="8" y="15" width="12" height="3"/>
        ]
    }
    return IconWrapper(
        <g>
            {path.map((e,i) => ({...e, key: i}))}
        </g>,
        size ?? 16
    )
}


export {
    AddTagIcon,
    EditTagIcon,
    DeleteTagIcon,
    ListTagsIcon,
    TagsLegendIcon,
}